import { inject, Injectable } from '@angular/core';
import { ExportSelection, SelectionAction } from 'gung-list';
import {
  Product,
  ProductExportActionConfigService
} from 'gung-standard';
import { first, map, Observable, of } from 'rxjs';
import { CarLinerPdfDownloadIndicatorServiceService } from './car-liner-pdf-download-indicator-service.service';

@Injectable({
  providedIn: 'root'
})
export class CarLinerProductExportActionConfigService extends ProductExportActionConfigService {

  protected carLinerpdfDownloadIndicatorService = inject(CarLinerPdfDownloadIndicatorServiceService);
 
  getSelectionActions(): Observable<SelectionAction<Product>[]> {
    return this.authService.getRoles().pipe(
      first(),
      map(roles => {
        const userActions: SelectionAction<Product>[] = [
          {
            label: 'PRODUCT_EXPORT_XLSX',
            performAction: (selection: ExportSelection<Product>) => {
              const itemList = Object.values(selection.selectedItems);
              this.productExportService.exportExcel(itemList).pipe(first()).subscribe();
              return of();
            }
          },
          {
            label: 'PRODUCT_EXPORT_IMG',
            performAction: (selection: ExportSelection<Product>) => {
              const itemList = Object.values(selection.selectedItems);
              this.productExportService.exportImg(itemList).pipe(first()).subscribe();
              return of();
            }
          }
        ];
        return userActions;
      })
    );
  }

  getSelectionMarkingActions(): Observable<SelectionAction<Product>[]> {
    return this.authService.getRoles().pipe(
      first(),
      map(roles => {
        const actions: SelectionAction<Product>[] = [];

        return actions;
      })
    );
  }
}
